import { format } from 'date-fns';

import { IConfigOffer, ILoyaltyBetweenDates } from 'generated/sanity-graphql';
import { t } from 'state/intl/translations';

const formatDate = (date: string) => format(new Date(date), 'M/d');

export const useConfigOfferDateRangeMessage = (configOffer?: Pick<IConfigOffer, 'rules'>) => {
  if (!configOffer) {
    return '';
  }

  const { startDate, endDate } =
    configOffer?.rules?.find(
      (rule): rule is ILoyaltyBetweenDates => !!rule && rule.__typename === 'LoyaltyBetweenDates'
    ) || {};

  if (startDate && endDate) {
    return t('fromStartDateToEndDate', {
      startDate: formatDate(`${startDate}T00:00:00`),
      endDate: formatDate(`${endDate}T23:59:59`),
    });
  }

  return '';
};
